const TafelHeader = props => {
  return (
    <header>
      <h1>{ props.headerText }</h1>
    </header>
  );
}

export default TafelHeader;